
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community/groups/my-groups",
      function () {
        return require("private-next-pages/community/groups/my-groups.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community/groups/my-groups"])
      });
    }
  